import HeroSection from "./HeroSection";
import Banner from "../../Assets/Images/about_banner.png"; // Replace with actual path

function AboutTitle() {
  return (
    <div className="About-title">
      <HeroSection image={Banner} pageTitle="About Us" />
    </div>
  );
}

export default AboutTitle;
